import React from "react";
import { LIFECYCLE, lifecycleIndex, isTerminal, isWon } from "@/lib/lifecycle";
import { Check, X } from "lucide-react";

// A horizontal end-to-end tracker showing where a pursuit sits in its lifecycle.
export function JourneyStepper({ item, stage, compact = false }) {
  const currentIdx = lifecycleIndex(stage);
  const terminal = item ? isTerminal(item) : false;
  const won = item ? isWon(item) : false;
  const noBid = item && (item.status === "no_bid" || item.status === "declined" || item.status === "cancelled");

  return (
    <div data-testid="journey-stepper" className="flex items-center w-full">
      {LIFECYCLE.map((s, i) => {
        const done = i < currentIdx || (terminal && i <= currentIdx);
        const active = i === currentIdx && !terminal;
        const isOutcome = s.key === "outcome";
        let dot = "bg-white border-slate-300 text-slate-400";
        if (done) dot = "bg-[#003E87] border-[#003E87] text-white";
        if (active) dot = "bg-[#F4C400] border-[#F4C400] text-black shadow-sm ring-4 ring-[#F4C400]/20";
        if (isOutcome && terminal) {
          dot = won
            ? "bg-emerald-500 border-emerald-500 text-white"
            : noBid
            ? "bg-slate-400 border-slate-400 text-white"
            : "bg-rose-500 border-rose-500 text-white";
        }
        return (
          <React.Fragment key={s.key}>
            <div className="flex flex-col items-center shrink-0" style={{ minWidth: compact ? 44 : 64 }}>
              <div className={`w-7 h-7 rounded-full border-2 flex items-center justify-center text-[11px] font-semibold transition ${dot}`}>
                {done && !(isOutcome && terminal) ? <Check className="w-3.5 h-3.5" /> : null}
                {isOutcome && terminal && !won ? <X className="w-3.5 h-3.5" /> : null}
                {isOutcome && terminal && won ? <Check className="w-3.5 h-3.5" /> : null}
                {!done && !(isOutcome && terminal) ? i + 1 : null}
              </div>
              {!compact && (
                <div className="mt-1.5 text-center">
                  <div className={`text-[11px] font-medium leading-tight ${active ? "text-black" : done ? "text-slate-700" : "text-slate-400"}`}>{s.label}</div>
                  <div className="text-[9px] text-slate-400 leading-tight mt-0.5">{s.blurb}</div>
                </div>
              )}
            </div>
            {i < LIFECYCLE.length - 1 && (
              <div className={`h-0.5 flex-1 mb-0 ${compact ? "" : "-mt-6"} ${i < currentIdx ? "bg-[#003E87]" : "bg-slate-200"}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
